import * as React from "react";

import { Alert, Box, Stack, Typography } from "@platform/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faCheck, faGears, faPeopleGroup } from "@fortawesome/sharp-regular-svg-icons";
import { TemplateV2 } from "../../../models/TemplateV2";
import { WorkGroup } from "../../../models/WorkGroup";

interface ConfigurationProgressProps {
  onHandleErrorMessage: (message: string | null) => void;
  errorMessage: string | null;
  selectedTemplate?: TemplateV2;
  selectedGroups?: WorkGroup[];
  activeStep: number;
  totalSteps: number;
}

export default function ConfigurationProgress(props: ConfigurationProgressProps) {
  const handleCloseErrorMessage = () => {
    props.onHandleErrorMessage(null);
  };

  return (
    <>
      {props.errorMessage ? (
        <Alert
          onClose={handleCloseErrorMessage}
          severity="error"
          sx={{
            width: "calc(100% - 34px)",
            borderColor: "error.main",
            borderWidth: "1px",
            borderStyle: "solid",
          }}
        >
          {props.errorMessage}
        </Alert>
      ) : (
        <>
          {props.selectedTemplate && props.activeStep > 0 ? (
            <Box>
              <Typography
                aria-label="Template Setup Progress"
                variant="h6"
                sx={{
                  color: "black",
                  backgroundColor: "#E3F3FA",
                  padding: "12px",
                }}
              >
                <FontAwesomeIcon
                  icon={faBriefcase}
                  style={{ paddingRight: "10px", color: "#000000" }}
                />
                Work Template: {props.selectedTemplate?.Title}{" "}
                {props.activeStep > 1 ? (
                  <span>
                    is setup <FontAwesomeIcon icon={faCheck} style={{ color: "#000000" }} />
                  </span>
                ) : null}
              </Typography>
            </Box>
          ) : null}

          {props.selectedGroups && props.selectedGroups.length > 0 && props.activeStep > 2 ? (
            <Box sx={{ paddingTop: "5px" }}>
              <Typography
                aria-label="Group Setup Progress"
                variant="h6"
                sx={{
                  color: "black",
                  backgroundColor: "#E3F3FA",
                  padding: "12px",
                }}
              >
                <FontAwesomeIcon
                  icon={faPeopleGroup}
                  style={{ paddingRight: "10px", color: "#000000" }}
                />
                Work Group(s):{" "}
                {props.selectedGroups?.map((group: any, index: number) => (
                  <>
                    {group?.Name}
                    {props.selectedGroups && index === props.selectedGroups.length - 1 ? " " : ", "}
                  </>
                ))}
                <span>
                  is setup <FontAwesomeIcon icon={faCheck} style={{ color: "#000000" }} />
                </span>
              </Typography>
            </Box>
          ) : null}

          {props.activeStep === props.totalSteps && (
            <Box sx={{ paddingTop: "5px" }}>
              <Typography
                aria-label="Final Template Status"
                variant="h6"
                sx={{
                  color: "black",
                  backgroundColor: "#E3F3FA",
                  padding: "12px",
                }}
              >
                <FontAwesomeIcon
                  icon={faGears}
                  style={{ paddingRight: "10px", color: "#000000" }}
                />
                Template is{" "}
                {props.selectedTemplate?.EnabledIndicator == true ? "Active" : "Inactive"}{" "}
                <FontAwesomeIcon icon={faCheck} style={{ color: "#000000" }} />
              </Typography>
              <Stack sx={{ paddingTop: "15px" }} spacing={1} alignItems="center">
                <Typography aria-label={"Final Summary"} variant={"h6"} sx={{ fontWeight: "bold" }}>
                  You're all set!
                </Typography>
              </Stack>
            </Box>
          )}
        </>
      )}
    </>
  );
}
